import {
  Currency,
  PaymentStatus,
  PaymentType,
  ProcessingStatus,
  SaPaymentTransactionQuery,
  SaPaymentTransactionsQuery,
} from '../graphql/graphql';

export type TPaymentTransaction = {
  id: string;
  stripePaymentId?: string;
  createdAt: string;
  amount: string;
  currency: Currency;
  paymentStatus: PaymentStatus;
  processingStatus: ProcessingStatus;
  paidAt: string;
  installationUuid: string;
  image?: string;
  paymentType: PaymentType;
  receiver: string;
  marketItem?: TPaymentMarketItem;
  metadata?: string;
  orderUuid?: string;
  simplicityPlus: boolean;
  identifier?: string;
  marketPaymentDetails?: TPaymentMarketPaymentDetails;
  refundDetails?: TPaymentRefundDetail[];
};

export type TPaymentsData =
  SaPaymentTransactionsQuery['paymentTransactionsByProcessingStatus']['paymentTransactions'];

export type TPaymentData = SaPaymentTransactionQuery['paymentTransaction'];

export type TPaymentMarketItem = NonNullable<
  SaPaymentTransactionQuery['paymentTransaction']
>['marketItem'];

export type TPaymentRefundDetail = NonNullable<NonNullable<TPaymentData>['refundDetails']>[number];
export type TPaymentMarketPaymentDetails = NonNullable<
  NonNullable<TPaymentData>['marketPaymentDetails']
>;

export type TPaymentMarketPaymentsDetails = NonNullable<
  NonNullable<TPaymentsData>[number]['marketPaymentDetails']
>;

export type TTuiRefundDetail = Extract<
  NonNullable<TPaymentRefundDetail>,
  { __typename: 'TUIRefundDetail' }
>;

export type TTuiWebhookRefundDetail = Extract<
  NonNullable<TPaymentRefundDetail>,
  { __typename: 'TUIWebhookRefundDetail' }
>;

export const isTuiRefundDetail = (
  refundDetail: TPaymentRefundDetail,
): refundDetail is TTuiRefundDetail => refundDetail.__typename === 'TUIRefundDetail';

export const isTuiWebhookRefundDetail = (
  refundDetail: TPaymentRefundDetail,
): refundDetail is TTuiWebhookRefundDetail => refundDetail.__typename === 'TUIWebhookRefundDetail';
